/** Список полей */
const columnDataGrid = [
  {
    dataField: 'isActive',
    caption: '',
    dataType: 'boolean',
    width: 75,
    cellRenderer: 'statusCellRenderer'
  },
  {
    dataField: 'operationTypeName',
    dataType: 'string',
    caption: 'Название',
    width: 200,
    cellRenderer: 'operationNamesCellRenderer'
  }
];

const columnAttrDataGrid = [
  {
    dataField: 'inheritParentDesc',
    dataType: 'string',
    caption: 'Тип наследования',
    width: 200
  },
  {
    dataField: 'attribCode',
    dataType: 'string',
    caption: 'Код атрибута',
    width: 200
  },
  {
    dataField: 'attribDescr',
    dataType: 'string',
    caption: 'Наименование',
    width: 200
  }
];
const columnAttrList = [
  {
    dataField: 'attribCode',
    dataType: 'string',
    caption: 'Код атрибута'
  },
  {
    dataField: 'attribDescr',
    dataType: 'string',
    caption: 'Наименование'
  }
];

export { columnDataGrid, columnAttrDataGrid, columnAttrList };
